import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';

import { HttpClient } from './global-http.service';
// Model
import {Geofence, Coordinates, Circle, GeofenceCategory, IMarker, GeofenceGrpCreateForm, IUpdateGeofencesGroups} from '../_models/geofence';


@Injectable()
export class GeofenceService {
  public data: any;

  constructor(
    private http: Http,
    private httpClient: HttpClient) {
  }

  // createGroup(GroupName: string): Observable<Response> {
  //   return this.http.post('/api/geofence_groups', JSON.stringify({
  //     GroupName: GroupName
  //   }), {
  //     headers: new Headers({
  //       'Content-Type': 'application/json'
  //     })
  //   })
  //   .map((response: Response) => {
  //   	console.log('geofence Group service: ', response);
  //  		return response.json();
  //   });
  // }

  createGeofence(Geofence: Object) {
    const api = '/api/geofence/';
    this.data = this.httpClient.post(api, Geofence);
    return this.data;
  }
  updateGeofence(Geofence: Object, id: number) {
    const api = `/api/geofence/${id}/`;
    this.data = this.httpClient.put(api, Geofence);
    return this.data;
  }

  getGeofence(id: number) {
    const api = `/api/geofence/${id}/`;
    console.log('service getGeofence: url:', api, 'id: ', id);
    this.data = this.httpClient.get(api);
    return this.data;
  }
  // update the Groups that are assigned to the Geofence
  updateGroupsOfGeofence(groups: IUpdateGeofencesGroups, id: number) {
    const api = `/api/geofence/${id}/`;
    this.data = this.httpClient.post(api, groups);
    return this.data;
  }


  // Group geofence
  createGroup(GroupName: string) {
    const apiAddNewVehicleGroups = '/api/geofence_groups/';
    this.data = this.httpClient.post(apiAddNewVehicleGroups, GroupName);
    return this.data;
  }
  

  getGroupList() {
    const api = '/api/geofence_groups_list/';
    this.data = this.httpClient.get(api);
    return this.data;
  }
  getGroup() {
    const api = '/api/geofence_groups/';
    this.data = this.httpClient.get(api);
    return this.data;
  }

  deleteGroup(name: string): Observable<Response> {
    return this.httpClient.delete('/api/geofence_groups');
  }

  // Category geofence
  createCategory(category: string): Observable<GeofenceCategory>{
    const catApi = '/api/geofence_categories/';
    this.data = this.httpClient.post(catApi, category);
    return this.data;
  }

  getCategories() {
    const api = '/api/geofence_categories/';
    this.data = this.httpClient.get(api);
    return this.data;
  }

  deleteCategory(name: string): Observable<Response> {
    return this.http.delete('/api/geofence_categories')
  }
}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/_services/geofence.service.ts